export default __webpack_public_path__ + "static/media/logo.b34d5f0e.png";